export const API = "https://milni.onrender.com/api/v1"
// export const API = "http://localhost:5000/api/v1"
export const cloudname = "narutoloves"
export const cloudinary_preset = "naruto-uploads"
